import { SelectionCategories } from '@revelio/iso-utility';

import {
  AdditionalReportSelectionCategories,
  type ReportSelectionCategories,
} from '../utils';

export const GEOGRAPHY_GRANULARITY_FILTERS_WITH_STATE = [
  SelectionCategories.REGION,
  SelectionCategories.COUNTRY,
  SelectionCategories.STATE,
  SelectionCategories.METRO_AREA,
];

export const shouldUseLegacyReportSelectionsModal = (
  selectionLists: ReportSelectionCategories[]
) => {
  return (
    selectionLists.some((s) => isACompanySelectionList(s)) ||
    isGeographyGranularityWithState(selectionLists)
  );
};

export const isACompanySelectionList = (list: ReportSelectionCategories) => {
  return (
    list === SelectionCategories.COMPANY ||
    list === AdditionalReportSelectionCategories.COMPANY_REPVUE ||
    list === AdditionalReportSelectionCategories.COMPANY_ORGCHART
  );
};

export const isGeographyGranularityWithState = (
  selectionLists: ReportSelectionCategories[]
) => {
  return (
    selectionLists?.every((s) => {
      return GEOGRAPHY_GRANULARITY_FILTERS_WITH_STATE.includes(
        s as SelectionCategories
      );
    }) &&
    selectionLists?.length === GEOGRAPHY_GRANULARITY_FILTERS_WITH_STATE.length
  );
};
